import React, { Component } from 'react'
import {Button, Modal, Row, Col, Popover} from 'antd'
import moment from 'moment'
import Countdown from 'react-countdown'
import ReactPlayer from 'react-player'
// img
import RecordResourceIcon from '../../../../assets/image/chapter/recordResource.svg'

import EndLiveImg from '../../../../assets/image/chapter/endlive.svg'
// service 
import AppService from '../../../../components/service/app.service'
// model
import SpaceLiveClientUrl from '../../models/spaceLiveClientUrl'
import RoomLiveDto from '../../../models/leco/roomLive/roomLiveDto'


import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.less';
import 'swiper/components/navigation/navigation.less';

interface LiveProps {
    title: string,
    playUrl: string,
    startTime: string, 
    endTime: string, 
    classStatus: string,
    liveType: string,
    liveLink: string,
    liveExtraData: string
}

interface iProps {
    extraProps: any
}
interface iState {
    spaceLiveClientUrl: SpaceLiveClientUrl,
    countDown: number,
    showGoLiveBtn: boolean,
    currentRecordIndex: number,
    videoState: boolean,
    url: string,
    roomLivevideoState: boolean,
    roomLiveDetails: RoomLiveDto,
    currentRoomNo: string,
    currentCameraNo: string,
    roomLiveId: string
}

const {confirm} = Modal
let countdownInterval = null 
// 录播视频
let videoplayer, roomLiveVideoPlayer
SwiperCore.use([Navigation])
export default class clazzClassIn extends Component<iProps, iState> {
    private appService: AppService = new AppService()
    state:iState = {
        spaceLiveClientUrl: new SpaceLiveClientUrl(),
        countDown: 1,
        showGoLiveBtn: true,
        currentRecordIndex: 0,
        videoState: false,
        url: '',
        roomLivevideoState: false,
        roomLiveDetails: new RoomLiveDto(),
        currentRoomNo: '',
        currentCameraNo: '',
        roomLiveId: ''
    }
    // 操作视频播放组件的对象
    roomliveref = player => { roomLiveVideoPlayer = player }
    // 获取直播或录播地址
    getUrl = async () => {
        let {extraProps} = this.props
        let {roomLiveExtraDataDtos, classStatus} = extraProps
        if (roomLiveExtraDataDtos && roomLiveExtraDataDtos.length) {
            let {roomLiveId, roomNo, cameras} = roomLiveExtraDataDtos[0]
            let url = ''
            if (cameras.length) {
                if (!(this.state.currentCameraNo && this.state.currentRoomNo)) {
                    await this.setState({currentRoomNo: roomNo, currentCameraNo: cameras[0], roomLiveId })
                }
                if (classStatus === 'ONGING' || classStatus === 'UNSTART') {
                    url = await this.appService.getUrl({url: '/common/roomlive/generatorLiveUrl', roomLiveId: this.state.roomLiveId, roomNo: this.state.currentRoomNo, cameraNo: this.state.currentCameraNo})
                } else if (classStatus === 'END') {
                    url = await this.appService.getUrl({url: '/common/roomlive/generatorRecordUrl', roomLiveId: this.state.roomLiveId, roomNo: this.state.currentRoomNo, cameraNo: this.state.currentCameraNo})
                }
                console.log(url)
                this.setState({url})
            }
            
        }
    }
    // 观看直播或录播
    toWatch = async (cameraNo: string, roomNo: string) => {
        if (cameraNo === this.state.currentCameraNo && roomNo === this.state.currentRoomNo) {
            return false
        }
        await this.setState({currentCameraNo: cameraNo, currentRoomNo: roomNo})
        this.getUrl()
    }
    // 判断URL是否合法
    jugeUrl = (URL) => {
        var str = URL;
        //判断URL地址的正则表达式为:http(s)?://([\w-]+\.)+[\w-]+(/[\w- ./?%&=]*)?
        //下面的代码中应用了转义字符"\"输出一个字符"/"
        var Expression = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;
        var objExp = new RegExp(Expression);
        if (objExp.test(str) == true) {
            return true;
        } else {
            return false;
        }
    }
    // 获取直播的链接
    getSpaceLiveUrl = async (jump = false) => {
        let {extraProps} = this.props
        let {client = '', clazzId:classId = '', classStatus = '', liveType, generateLiveUrl = ''} = extraProps
        let spaceLiveClientUrl = await this.appService.getSpaceLiveUrl({url: generateLiveUrl ? generateLiveUrl: `/leco/ecology/api/v1/${client}/spaceLive/clientUrl`, classId})
        await this.setState({spaceLiveClientUrl})
        if (liveType === 'CLASS_IN') {
            if (spaceLiveClientUrl.liveUserExtraState === 'REGISTERED') {
                if (classStatus === 'ONGING' || jump) {
                    window.open(spaceLiveClientUrl.url, '_blank')
                } else {
                    this.setState({showGoLiveBtn: true})
                }
            } else if (spaceLiveClientUrl.liveUserExtraState === 'UN_REGISTER') {
                confirm({
                    title: "用户未注册classin账号提醒",
                    content: '您当前未注册classin账号，请去【个人中心】绑定手机号，绑定后系统将用该手机号自动注册classin账号！',
                    okText: "去绑定",
                    cancelText: "取消",
                    onOk: () => {
                        window.location.href = `${window.location.origin}/fe-pc/b/galaxy-portal2/fe_system_personal`
                    },
                });
            } else if (spaceLiveClientUrl.liveUserExtraState === 'ABNORMAL') {
                confirm({
                    title: "用户classin账号异常提醒",
                    content: '您在学习平台中维护的classin注册手机号与classin不一致，请联系管理员在学习平台中修改classin手机号！',
                    okText: "我知道了",
                    cancelText: "取消",
                    onOk: () => {
                    },
                });
            }
        } else if (liveType === 'HUO_DE') {
            if (classStatus === 'ONGING' || jump) {
                window.open(spaceLiveClientUrl.url, '_blank')
            } else {
                this.setState({showGoLiveBtn: true})
            }
        }
        
    }
    componentDidMount () {
        let {extraProps} = this.props
        let {liveType, liveLink, classStatus, startTime} = extraProps
        if (liveType === 'CLASS_IN' || liveType === 'HUO_DE') {
            this.getSpaceLiveUrl()
        } else if (liveType === 'LINK' && liveLink) { 
            if (this.jugeUrl(liveLink) && classStatus === 'ONGING') { // 跳转至外链 
                window.open(liveLink, '_blank')
            } else {
                this.setState({showGoLiveBtn: false})
            }
        } else if (liveType === 'ROOM_LIVE') {
            this.getUrl()
            this.setState({showGoLiveBtn: false})
        }
        if (classStatus === 'UNSTART') {
            let that = this
            // 选课倒计时定时器·
            countdownInterval = setInterval(() => {
                if ((startTime - new Date().getTime()) <= 0) {
                    if (!that.state.spaceLiveClientUrl.liveUserExtraState && (liveType === 'CLASS_IN' || liveType === 'HUO_DE')) {
                        that.getSpaceLiveUrl(true)
                    } else if (that.jugeUrl(liveLink) && liveType === 'LINK') {
                        window.open(liveLink, '_blank')
                    } else if (liveType === 'ROOM_LIVE') {
                        this.getUrl()
                    }
                    that.setState({countDown: 0})
                    countdownInterval && clearInterval(countdownInterval)
                } else {
                    that.setState({countDown: startTime - new Date().getTime()})
                }
            },1000)
        }
    }
     // 阻止视频右键点击下载
    onContextMenu(e){
        e.preventDefault()
        // alert("右单击")
    }
    ref = player => { videoplayer = player }
    // 视频播放结束
    videoEnd = () => {
        let currentRecordIndex = this.state.currentRecordIndex + 1
        this.setState({currentRecordIndex})
    }
    // 切换录播视频
    changeCurrentVideo = async (currentRecordIndex) => {
        if (currentRecordIndex === this.state.currentRecordIndex) {
            return false
        } else {
            this.setState({currentRecordIndex})
        }
    }
    componentWillUnmount() {
        countdownInterval && clearInterval(countdownInterval)
    }
    render() {
        let {extraProps} = this.props
        let {countDown, showGoLiveBtn, spaceLiveClientUrl, currentRecordIndex, videoState,
            currentRoomNo, currentCameraNo, url, roomLivevideoState} = this.state
        return (
            <div className="clazzClassIn">
                {/* 直播未开始 */}
                {
                    (extraProps.classStatus === 'UNSTART' && countDown >0) &&
                    <>
                        <div className="clazzClassIn_liveExtraData">
                            <div className="clazzClassIn_liveExtraData_title">直播时间：</div>
                            <div className='clazzClassIn_liveExtraData_content'>
                                直播将于 {moment(extraProps.startTime || 0).format('YYYY-MM-DD HH:mm')}开始，
                                {moment(extraProps.endTime || 0).format('YYYY-MM-DD HH:mm')}结束
                            </div>
                        </div>
                        <div className="clazzClassIn_liveExtraData">
                            <div className="clazzClassIn_liveExtraData_title">倒计时：</div>
                            <div className='clazzClassIn_liveExtraData_content'>
                                <Countdown date={extraProps.startTime}
                                    renderer={props => <div className="clazzClassIn_countdown">
                                        <span>{props.days}</span>天
                                        <span>{props.hours}</span>小时
                                        <span>{props.minutes}</span>分钟
                                        <span>{props.seconds}</span>秒
                                </div>} />
                            </div>
                        </div>
                        <div className='clazzClassIn_liveExtraData'>
                            <div className="clazzClassIn_liveExtraData_title">直播信息：</div> 
                            <div className='clazzClassIn_liveExtraData_content'>
                                {extraProps.liveExtraData}
                            </div>
                        </div>
                        {showGoLiveBtn&&
                            <div className="clazzClassIn_golive">
                                <Button size="large" onClick={() => window.open(spaceLiveClientUrl?.url, '_blank')} type="primary">进入教室</Button>
                            </div>
                        }
                    </>
                }

                {/* 直播进行中 */}
                {
                    (extraProps.classStatus === 'ONGING' || (extraProps.classStatus === 'UNSTART' && countDown <= 0)) && extraProps.liveType !== 'ROOM_LIVE' &&
                    <div className="clazzClassIn_onging">
                        <div><img src={EndLiveImg} /></div>
                        {/* 直播类型为CLASS_IN或者直播类型为LINK（要有链接liveLink），且注册过 */}
                        {
                            (
                                (spaceLiveClientUrl?.liveUserExtraState === 'REGISTERED' && extraProps.liveType === 'CLASS_IN') ||
                                (extraProps.liveType === 'HUO_DE') ||
                                (extraProps.liveType === 'LINK' && extraProps.liveLink)
                            ) &&
                            <div className="clazzClassIn_end_tag">已打开直播链接，请到具体直播平台查看</div>
                        }
                        {/* 直播类型为LINK（没有链接liveLink） */}
                        {
                            extraProps.liveType === 'LINK' && !extraProps.liveLink &&
                            <div className="clazzClassIn_liveExtraData">
                                <div className="clazzClassIn_liveExtraData_title">直播信息：</div>
                                <div className='clazzClassIn_liveExtraData_content'>{extraProps.liveExtraData}</div> 
                            </div>
                        }
                        {/* {
                            extraProps.livePhone &&
                            <div className="clazzClassIn_phone">classin手机号：{extraProps.livePhone}</div>
                        } */}
                    </div>
                }

                {/* 直播已结束 */}
                {extraProps.classStatus === 'END' && extraProps.liveType !== 'ROOM_LIVE' &&
                    ((extraProps.recordResource && !!(extraProps.recordResource.length)) ? 
                    <div className="clazzClassIn_live_recordresource" >
                        <div className="clazzClassIn_live_recordresource_container">
                            <div className='clazzVideo player-wrapper clazzRecord'  onContextMenu={this.onContextMenu.bind(this)}>
                            <ReactPlayer
                                ref={this.ref}
                                className='react-player' 
                                url={extraProps.recordResource[this.state.currentRecordIndex]?.playUrl}
                                controls={true}
                                onContextMenu={(e) => e.preventDefault()}
                                config={{
                                  file: { attributes: { controlsList: "nodownload noplaybackrate" ,disablePictureInPicture: true} },
                                }}
                                // progressInterval={100}
                                playing={videoState}
                                width='100%'
                                height='100%'
                                onEnded={this.videoEnd}
                                // onPlay={this.videoPlay}
                                // onPause={this.videoPause}
                            />
                            </div>
                            <div className="clazzClassIn_live_recordresource_title">
                                <div className="clazzClassIn_live_recordresource_title_text">录播片段（{extraProps.recordResource.length}）</div>
                                <div className="clazzClassIn_live_recordresource_title_tip">
                                    该直播回放包含<span>{extraProps.recordResource.length}</span>个录播视频
                                </div>
                            </div>
                            <Swiper
                                style={{width: '100%'}}
                                slidesPerView={6}
                                spaceBetween={20}
                                navigation
                                onSlideChange={() => console.log('slide change')}
                                onSwiper={(swiper) => console.log(swiper)}
                                >
                                    {
                                    extraProps.recordResource.map((recorditem, index) => 
                                        <SwiperSlide key={recorditem.id}>
                                            <div onClick={this.changeCurrentVideo.bind(null, index)} style={{border: index === currentRecordIndex ? '1px solid #1890FF' : ''}} className="clazzClassIn_live_recordresource_item">
                                                <img src={RecordResourceIcon} alt="" />
                                            </div>
                                        </SwiperSlide>
                                    )
                                }
                            </Swiper>
                        </div>
                    </div>:
                    <div className="clazzClassIn_end">
                        <div><img src={EndLiveImg}  /></div>
                        <div className="clazzClassIn_end_tag">直播已结束</div>
                    </div>)
                }
                {
                    extraProps.liveType === 'ROOM_LIVE' && (extraProps.classStatus !== 'UNSTART' || countDown <= 0) &&
                    <div>
                        <Popover className='roomlive-priview-popover' placement="rightTop" content={<div className='roomlive-priview-camera-select-container'>
                            {
                                (extraProps.roomLiveExtraDataDtos??[]).map(item => 
                                    <div className='roomlive-priview-roomItem'>
                                        <div className='roomlive-priview-roomItem-address'>
                                            {item.address}/{item.roomName}{!(item.cameras && !!(item.cameras.length)) ? '(无摄像头)': ''}
                                        </div>
                                        {
                                            extraProps?.classStatus !== 'UNSTART' &&
                                            (item.cameras??[]).map((cameraItem, index) => 
                                                <div className={`roomlive-priview-cameraitem ${(currentCameraNo === cameraItem && currentRoomNo === item.roomNo) && 'roomlive-priview-cameraitem-selected'}`} onClick={this.toWatch.bind(null, cameraItem, item.roomNo)}>{extraProps?.classStatus === 'END' ? '查看录播': '进入教室'}{index+1}</div>
                                            )
                                        }
                                    </div>    
                                )
                            }
                        </div>} title="">
                            <div className='roomlive-priview-camera-select'>

                            </div>
                        </Popover>
                        {
                        url &&
                        <div className='clazzClassIn-roomlive'>
                            {
                                (extraProps.classStatus === 'ONGING' || extraProps.classStatus === 'UNSTART') &&
                                <ReactPlayer 
                                    className='react-live'
                                    //这里是由上级页面传过来的视频地址
                                    url={url}
                                    playing
                                    width='100%'
                                    height='100%'
                                    controls
                                    onContextMenu={(e) => e.preventDefault()}
                             
                                    config={{
                                        file: {
                                        attributes: { controlsList: "nodownload noplaybackrate" ,disablePictureInPicture: true},
                                        forceHLS: true, 
                                            hlsOptions: {
                                                levelLoadingMaxRetry: 30,
                                                levelLoadingMaxRetryTimeout: 32000
                                            }
                                        }
                                    }}
                                />
                            }
                            {
                                extraProps.classStatus === 'END' && 
                                <ReactPlayer
                                    ref={this.roomliveref}
                                    className='react-video' 
                                    url={url}
                                    controls={true}
                                    onContextMenu={(e) => e.preventDefault()}
                                    config={{
                                      file: { attributes: { controlsList: "nodownload noplaybackrate" ,disablePictureInPicture: true} },
                                    }}
                                    // progressInterval={100}
                                    playing={roomLivevideoState}
                                    width='100%'
                                    height='100%'
                                />
                            }
                        </div>
                    }
                    {
                        !url &&
                        <div>
                            <img src={EndLiveImg} />
                            <div style={{fontSize: 16, color: 'rgba(0,0,0,.85)', fontWeight: 500, textAlign: 'center', margin: '16px 0'}}>暂无{extraProps?.classStatus === 'END' ? '录播':'直播'}</div>
                        </div>
                    }
                    </div>
                }
            </div>
        )
    }
}
